var map = {
	"./Upholestry - Beige.webp": 45477,
	"./Upholestry - Black.webp": 50930,
	"./Upholestry - Brown.webp": 55429,
	"./Upholestry - Dark Red.webp": 48700,
	"./Upholestry - Gray.webp": 80284,
	"./Upholestry - White.webp": 64136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66760;